import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * L205 模組權限 hook
 * PgCode = "pwl205f1" (ISO稽核查檢表)
 */
export function useL205Permissions() {
  return useModulePermission(Modules.L205);
}
